module.exports = __webpack_public_path__ + "no.d3ab6c28.svg";